<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">矩阵管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div1">平台列表</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">平台设置</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <div class="Box">
      <div class="table_tab">
        <div class="inquiry">
          <div class="headerbox">
            <div class="header">
              <div class="title_left"></div>
              平台设置
            </div>
          </div>
        </div>
        <div class="inquiryTab">
          <div class="inquiryTab_average">
            <div class="table">
              <el-table
                v-loading="loading"
                :data="tableDataS"
                :header-cell-style="{
                  background: '#f8f8f8',
                  textAlign: 'left',
                }"
                style="width: 100%"
                :toggleRowExpansion="{ expanded: true }"
                ref="theTable"
                :row-style="{ height: '135px' }"
              >
                <el-table-column label="服务商等级" min-width="40">
                  <template slot-scope="props">
                    <el-input
                      size="small"
                      style="width: 100%"
                      v-model="props.row.name"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="允许上架数量"
                  prop="categoryNo"
                  min-width="50"
                >
                  <template slot="header">
                    <span>允许上架数量</span
                    ><el-tooltip
                      style="margin-left: 4px"
                      effect="dark"
                      content="各等级服务商平台上架商品的个数设置"
                      placement="top"
                    >
                      <i class="el-icon-question" style="color: #f2a626"></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="props">
                    <el-button type="primary" @click="settingNumber(props.row)"
                      >设置数量</el-button
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="普通商品比例"
                  prop="normalProportion"
                  min-width="50"
                >
                  <template slot="header">
                    <span>普通商品比例</span
                    ><el-tooltip
                      style="margin-left: 4px"
                      effect="dark"
                      content="各等级服务商售卖【普通商品】平台佣金设置的比例"
                      placement="top"
                    >
                      <i class="el-icon-question" style="color: #f2a626"></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="props">
                    <el-input
                      style="width: 80%"
                      @input="
                        (v) =>
                          (props.row.normalProportion = v.replace(
                            /[^0-9.]/g,
                            ''
                          ))
                      "
                      size="small"
                      v-model="props.row.normalProportion"
                    >
                    </el-input
                    ><span class="marginClass">%</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="礼包商品比例"
                  prop="giftPackageProportion"
                  min-width="50"
                >
                  <template slot="header">
                    <span>礼包商品比例</span
                    ><el-tooltip
                      style="margin-left: 4px"
                      effect="dark"
                      content="各等级服务商售卖【礼包商品】平台佣金设置的比例"
                      placement="top"
                    >
                      <i class="el-icon-question" style="color: #f2a626"></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="props">
                    <el-input
                      style="width: 80%"
                      @input="
                        (v) =>
                          (props.row.giftPackageProportion = v.replace(
                            /[^0-9.]/g,
                            ''
                          ))
                      "
                      size="small"
                      v-model="props.row.giftPackageProportion"
                    >
                    </el-input
                    ><span class="marginClass">%</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="身份商品比例"
                  prop="vipProportion"
                  min-width="50"
                >
                  <template slot="header">
                    <span>身份商品比例</span
                    ><el-tooltip
                      style="margin-left: 4px"
                      effect="dark"
                      content="各等级服务商售卖【身份商品】平台佣金设置的比例"
                      placement="top"
                    >
                      <i class="el-icon-question" style="color: #f2a626"></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="props">
                    <el-input
                      style="width: 80%"
                      @input="
                        (v) =>
                          (props.row.vipProportion = v.replace(/[^0-9.]/g, ''))
                      "
                      size="small"
                      v-model="props.row.vipProportion"
                    >
                    </el-input
                    ><span class="marginClass">%</span>
                  </template>
                </el-table-column>
                <el-table-column label="说明" prop="remarks" min-width="50">
                  <template slot-scope="props">
                    {{ props.row.remarks }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="submit">
            <el-button
              class="submit_btn"
              type="primary"
              @click="back"
              style="background-color: #f2a626; border: 1px solid #f2a626"
              >返 回</el-button
            >
            <el-button class="submit_btn" type="primary" @click="save"
              >确 认</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="设置数量"
      :visible.sync="dialogUser"
      append-to-body
      width="780px"
    >
      <div class="dialog-search">
        <div style="display: flex">
          <div>默认允许上架数量</div>
          <div style="margin-left: 8px; margin-right: 8px">
            <el-input
              style="width: 86px"
              placeholder="请输入个数"
              v-model="maxGoodsNum"
              size="small"
              clearable
            ></el-input>
          </div>
          <div>个</div>
        </div>
        <div style="display: flex">
          <div style="margin-right: 20px">
            <el-input
              placeholder="请输入用户信息"
              clearable
              v-model="keywords"
              size="small"
            ></el-input>
          </div>
          <div>
            <el-button type="primary" @click="searchData">查询</el-button>
          </div>
        </div>
      </div>
      <div>
        <div style="max-height: 400px; overflow-y: auto; margin-top: 20px">
          <el-table
            border
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; margin-bottom: 10px"
          >
            <el-table-column label="用户ID" width="160px" prop="userId">
            </el-table-column>
            <el-table-column prop="username" label="用户昵称" width="120">
            </el-table-column>
            <el-table-column prop="phone" label="电话号码" width="160px">
            </el-table-column>
            <el-table-column prop="address" label="允许个数">
              <template slot-scope="scope">
                <div style="display: flex">
                  <div>
                    <el-input
                      placeholder="请输入个数"
                      clearable
                      v-model="scope.row.maxGoodsNum"
                      size="small"
                    ></el-input>
                  </div>
                  <div style="line-height: 30px; margin-left: 8px">个</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="float: right; margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
        <div
          style="
            width: 780px;
            height: 0px;
            border: 1px solid #d9d9d9;
            opacity: 1;
            margin-top: 70px;
          "
        ></div>
        <div style="margin-top: 14px; display: flex; justify-content: flex-end">
          <div class="c-btn" @click="dialogUser = false">取消</div>
          <div class="q-btn" type="primary" @click="submit">确认</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  watch: {
  },
  components: {
  },
  data () {
    return {
      pageNo: 1,
      pageSize: 10,
      tableData: [
        {}, {}, {}
      ],
      dialogUser: false,
      loading: false,
      fileListImg: [], // 上传图片
      imageUrl: '',
      input1: '', //
      parArray: [], //
      tableData: [],
      lastTime: 0,
      maxGoodsNum: 0,
      keywords: '',
      tableDataS: [],
      total: '',
      vipId: ''
    }
  },
  mounted () {
  },
  created () {
    // 权限设定判断
    this.limits = JSON.parse(sessionStorage.getItem('limit'))
    const params = this.limits.buttonTreeDto.filter(
      (item) => item.menuCode === 'GiftManage1'// 菜单管理里面的菜单编码
    )
    params[0].buttonList.forEach((item) => {
      this.parArray.push(item.code)
    })
    console.log(this.parArray)
    // 权限设定判断
    document.onkeydown = (e) => {
      const key = window.event.keyCode
      if (key == 13) {
        this.searchEvent()
      }
    }
    this.getDataList()
    this.fetchData()
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    save () {
      this.$api.saveVipConfig(this.tableDataS).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '保存成功!'
          })
        }
      })
    },
    submit () {
      let arr = []
      this.tableData.forEach(item => {
        let obj = {
          id: item.id,
          maxGoodsNum: item.maxGoodsNum
        }
        arr.push(obj)
      })
      let data = {
        id: this.vipId,
        maxGoodsNum: this.maxGoodsNum,
        platforms: arr
      }
      this.$api.saveMaxConfigs(data).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '设置成功!'
          })
          this.dialogUser = false
        }
      })
    },
    handleCurrentChange (currentChange) {
      this.pageNo = currentChange
      this.fetchData()

    },
    handleSizeChange (sizeChange) {
      this.pageSize = sizeChange
      this.fetchData()
    },
    searchData () {
      this.pageNo = 1
      this.pageSize = 10
      this.fetchData()
    },
    fetchData () {
      let data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keywords: this.keywords,
        vipId: this.vipId,
      }
      this.$api.getMaxConfigPageList(data).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.list
          this.total = res.data.totalNum
        }
      })
    },
    settingNumber (row) {
      this.dialogUser = true
      this.maxGoodsNum = row.maxGoodsNum
      this.vipId = row.id
      this.keywords = ''
      this.fetchData()
    },
    getDataList () {
      this.loading = true
      const params = {
      }
      this.$api.getVipConfig(params).then((res) => {
        if (res.code == 0) {
          this.loading = false
          this.tableDataS = res.data
        } else {
          this.loading = false
        }
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    deleteImg (index) {
      console.log(index, 'index')
      this.tableData[index].mainImage = ''
    },
    // 上传图片
    test () {
      this.$message.warning(
        '只能上传1张'
      )
    },
    imgUpload (response, index) {
      console.log(response, index, 'fileObj')
      // const length = this.form.fileListImg.length
      const formData = new FormData()
      formData.append('file', response.file)

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.axios
        .post(
          '/sys/v1/common/upload/files?pathName=internalSystem',
          formData,
          config,
          {
            headers: {
              isLoading: false
            }
          }
        )
        .then((res) => {
          if (res.code == 0) {
            console.log(res, 'res')
            // this.imageUrl = res.data.url;
            // const obj = {
            //   img: res.data.url,
            //   creattime: new Date().toLocaleDateString()
            // }
            this.tableData[index].mainImage = res.data.url
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleAvatarSuccess (res, file, dfdds, index) {
      console.log(res, file, dfdds, index, 'res, file')
      const aaaa = {
        uploadFilePath: file.raw,
        fileName: file.name
      }
      console.log(this.tableData, 'this.tableData')
      this.tableData[index].image.push(aaaa)
    },
    beforeAvatarUpload (file) {
      console.log(file, 'file')
      const isJPGorPNG = file.type === 'image/jpeg'
      // const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      console.log(isJPGorPNG, 'isJPG')
      if (isJPGorPNG === false) {
        this.$message.error('上传图片只能是 JPG 格式！')
        // this.$message.error('上传图片只能是 JPG或PNG 格式')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPGorPNG && isLt2M
    }
  }
}
</script>
<style scoped lang="scss">
.c-btn {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #999999;
  text-align: center;
  margin-right: 24px;
  cursor: pointer;
}
.q-btn {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #ffffff;
  opacity: 1;
  text-align: center;
  cursor: pointer;
}
.dialog-search {
  display: flex;
  width: 100%;
  justify-content: space-between;
  // margin-top: 10px;
  // margin-left: 10px;
  line-height: 40px;
}
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.member {
  width: 100px;
}

.el-menu-vertical-demo {
  width: 200px;
  overflow-y: scroll;
  height: 700px;
}

.el-menu-input {
  padding: 0 15px;
  background: #fff;

  /deep/ .el-input__inner {
    height: 30px;
    border: 1px solid #eee;
    margin: 10px 0;
  }
}

.el-menu-vertical-demo::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.Box {
  display: flex;
  justify-content: flex-start;
  width: 100%;

  .table_tab {
    width: 100%;
    margin-bottom: 50px;
  }
}

.table {
  border-radius: 5px;
  width: 100%;
}

/deep/.distpicker-address-wrapper select {
  padding: 0rem 0.75rem;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
}

/deep/.el-table__expanded-cell[class*="cell"] {
  padding: 0px 50px;
}

/deep/.el-table td,
.el-table th {
  // text-align: left;
}

.header {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  // padding-bottom: 10px;
}

.inquiry {
  background: #fff;
  padding: 10px 20px 10px 20px;
  border-radius: 5px;

  .el-form {
    margin-top: 10px;
  }
}

.inquiryTab {
  background: #fff;
  padding: 10px 20px 20px 20px;
  border-radius: 5px;

  .inquiryTab_average {
    display: flex;
  }

  .inquiryTab_right {
    width: 18%;
    margin-top: 10px;
    border: 1px solid #e8eaec;
    margin-left: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
  }

  .el-form {
    margin-top: 10px;
  }

  margin-top: 20px;
}

/deep/.el-table__expand-icon > .el-icon {
  color: transparent;
}

.table {
  margin-top: 10px;
  border: 1px solid #e8eaec;
  border-radius: 0;

  /deep/ .el-input--suffix .el-input__inner {
    background: #409eff;
    color: #fff;
    width: 104px;
    box-shadow: none;
  }

  /deep/ .el-button {
    padding: 10px 13px;
  }
}

/deep/.el-table__row:hover {
  color: rgb(45, 125, 223);
}

.headerbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-bottom: 10px;
}

.title_left {
  width: 4px;
  height: 16px;
  background: #4c81eb;
  opacity: 1;
  margin-right: 10px;
}

.tabTitle {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #333333;
  opacity: 1;
  margin-top: 10px;
  margin-bottom: 20px;
}

.headerTitle {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  margin-top: 20px;
  margin-bottom: 15px;
}

/deep/.el-form-item__label {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

/deep/.el-table thead {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #333333;
  opacity: 1;
}

.inputClass {
  width: 80%;
}

.submit {
  display: flex;
  justify-content: center;
}

.marginClass {
  margin-left: 10px;
}

.submit_btn {
  width: 150px;
  margin-top: 20px;
}

:deep(input::-webkit-outer-spin-button),
:deep(input::-webkit-inner-spin-button) {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

:deep(.el-textarea__inner) {
  height: 108px;
}
.tipsText {
  background-color: #409eff;
  color: white;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 18px;
  margin-left: 4px;
  cursor: pointer;
  font-size: 12px;
}
</style>
